<template>
    <el-row>
        <el-col :span="6">
            <div style="padding-top: 30px">
                <el-progress
                    color="#14b414"
                    :width="70"
                    type="circle"
                    :percentage="deliveryPrecision"
                ></el-progress>
            </div>
        </el-col>
        <el-col :span="14">
            <div style="margin-left: 15px">
                <h3 style="font-weight: bold;">
                    {{ $t('table.data.followup.deliveryPrecision') }}
                </h3>

                <table>
                    <tr>
                        <th width="50px" style="border-bottom: 1px solid;"></th>
                        <th
                            width="150px"
                            style="text-align: left;border-bottom: 1px solid;"
                        >
                            {{ $t('table.data.followup.deliveryPrecision') }}
                        </th>
                    </tr>
                    <tr>
                        <td width="50px" style="padding-top: 10px">
                            <span class="dot"></span>
                        </td>
                        <td
                            width="10px"
                            style="padding-top: 10px; text-align: left"
                        >
                            {{ deliveryPrecision }}%
                        </td>
                    </tr>
                </table>
            </div>
        </el-col>
    </el-row>
</template>

<script>
export default {
    name: 'CustomRadiusChart',
    props: {
        deliveryPrecision: 0,
    },
}
</script>

<style>
.dot {
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
    background-color: #14b414;
}

tr:hover {
    background-color: #e9edf6;
}
</style>
